import React from 'react';

export const Cordedloop = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 88.45 88.45"
      {...props}
    >
      <defs>
        <clipPath id="controlcordloop__clip-path">
          <circle cx={44.22} cy={44.22} r={36.5} fill="none" />
        </clipPath>
      </defs>
      <circle
        cx={44.22}
        cy={44.22}
        r={43.5}
        stroke="#27375f"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#fff"
        strokeWidth={1.45}
      />
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="matrix(.61 .8 -.8 .61 11.86 64.18)"
      >
        C
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="rotate(37 -98.715 62.855)"
      >
        O
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="rotate(21.43 -193.022 110.751)"
      >
        R
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="rotate(6.21 -732.6 373.65)"
      >
        D
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="rotate(-7.42 656.791 -317.559)"
      >
        L
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="rotate(-21.04 245.506 -104.568)"
      >
        O
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="matrix(.79 -.62 .62 .79 64.31 76.76)"
      >
        O
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold,Lato"
        fontWeight="700"
        transform="rotate(-53.25 105.788 -37.825)"
      >
        P
      </text>
      <g clipPath="url(#controlcordloop__clip-path)">
        <path
          d="M43-16.78s29 77 1 77-1-77-1-77z"
          strokeWidth={2}
          stroke="#27375f"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  );
};
